import { useContext, useEffect, useState } from "react";
import TabsAdultosCarta from "../Cartelera/TabsAdultosCarta/TabsAdultosCarta";
import Loading from "../General/Loading";
import CanalCmpnt from "../Cartelera/Canal";
import {
  builtConsultarCartelera_Entrada,
  ConsultarCartelera_Entrada,
  ConsultarCartelera_Parametros,
  ConsultarCartelera_Respuesta,
  Canal,
} from "../Commons/Services/ConsultarCartelera";
import { ConsultaWS } from "../Commons/ServiciosBase";
import ContextFlujos from "../Context/ContextFlujos";
import {
  ConsultaCuentaRest_Entrada,
  builtConsultaCuentaRestInput,
  ConsultaCuentaRest_Parametros,
  ConsultaCuenta_Respuesta,
  InstanceComponent,
  ServiceInstance,
} from "../Commons/Services/ConsultaCuentaRest";

const Cartelera = () => {
  const [muestraTabsAdultosCarta, setMuestraTabsAdultosCarta] = useState(true);
  const [indice, setIndice] = useState(0);
  const [origen, setOrigen] = useState("");
  const [loading, isLoading] = useState(false);

  const [arrayAplicaciones, setArrayAplicaciones] = useState<Canal[]>([]);

  const [arrayAdultos, setArrayAdultos] = useState<Canal[]>([]);

  const [consultaCuentaRespuesta, setConsultaCuentaRespuesta] =
    useState<ConsultaCuenta_Respuesta>();

  const { setSkyPlus, setSkyCelular, setDTHSkyPlus } = useContext(
    ContextFlujos
  ) as any;

  const [pais, setPais] = useState(sessionStorage.getItem("pais"));
  const [arregloOrdenado, setArregloOrdenado] = useState<any>([]);

  const ordenParaArreglo = [
    { original: "ViX Premium", nuevo: "ViX Premium" },
    {original: "Disney+ Estándar",nuevo: "Disney+ Estándar"},
    {original: "Disney+ Premium",nuevo: "Disney+ Premium"},
    { original: "Golden Premiere HD", nuevo: "Golden Premiere HD" },
    { original: "Golden Premiere prepago HD", nuevo: "Golden Premiere HD" },
    { original: "HBO/MAX A la Carta", nuevo: "Max" },
    { original: "HBO/MAX A la Carta Prep HD", nuevo: "Max" },
    { original: "Universal+ MX", nuevo: "Universal+" },
    { original: "Universal+ MX prepago HD", nuevo: "Universal+" },
    { original: "Fox Sports Pospago", nuevo: "Fox Sports Premium" },
    { original: "Fox Sports Prepago", nuevo: "Fox Sports Premium" },
  ];

  useEffect(() => {
    isLoading(true);
    if (sessionStorage.getItem("flujos") === "Sky+") {
      setSkyPlus({ estado: false });
      setDTHSkyPlus({ estado: false });
      setPais("MEX");
    }

    if (
      sessionStorage.getItem("flujos") === "DTH/SkyCelular" ||
      sessionStorage.getItem("flujos") === "DTH/DTH/SkyCelular/Sky+"
    ) {
      setSkyCelular({ estado: true });
    }

    if (
      sessionStorage.getItem("flujos") === "DTH/Sky+" ||
      sessionStorage.getItem("flujos") === "DTH/SkyCelular/Sky+"
    ) {
      setDTHSkyPlus({ estado: false });
    }

    if (
      sessionStorage.getItem("flujos") === "DTH" ||
      sessionStorage.getItem("flujos") === "DTH/SkyCelular"
    ) {
      setDTHSkyPlus({ estado: true });
    }

    getCanales();
  }, []);

  const getPaisIso = (param: string) => {
    if (param === "Mexico") {
      return "MX";
    } else if (param === "Costa Rica") {
      return "CR";
    } else if (param === "Guatemala") {
      return "GT";
    } else if (param === "Honduras") {
      return "HN";
    } else if (param === "Nicaragua") {
      return "NI";
    } else if (param === "Panama") {
      return "PA";
    } else if (param === "Republica Dominicana") {
      return "DO";
    } else if (param === "El Salvador") {
      return "SV";
    } else {
      return "MX";
    }
  };

  const getCanales = async () => {
    isLoading(true);
    //----------------------------------------------------------------------------------------------------------------------------
    const ConsultarCarteleraDO: ConsultarCartelera_Entrada =
      builtConsultarCartelera_Entrada(
        `${sessionStorage.getItem("Paquete")}`,
        `${sessionStorage.getItem("accountType")}`,
        `${sessionStorage.getItem("cuenta")}`,
        `${sessionStorage.getItem("assetNumberVideo")}`,
        `${sessionStorage.getItem("SecondAssetNumberVideo")}`,
        getPaisIso(sessionStorage.getItem("PrimaryAccountCountry")!)
      );

    let ConsultarCarteleraParametros =
      ConsultarCartelera_Parametros(ConsultarCarteleraDO);

    let ConsultarCarteleraRespuesta: ConsultarCartelera_Respuesta =
      await ConsultaWS(ConsultarCarteleraParametros);
    // Condicional para validar si la respuesta del servicio es correcta
    if (
      !ConsultarCarteleraRespuesta.dataArea.canales ||
      ConsultarCarteleraRespuesta.dataArea.canales == null ||
      ConsultarCarteleraRespuesta.dataArea.canales.length === 0
    ) {
      console.error(ConsultarCarteleraRespuesta);
      isLoading(false);
      return;
    }

    let canales = ConsultarCarteleraRespuesta.dataArea.canales;
    let ConsultaCuentaRestRet = await doConsultaCuentaRest();

    let arrayTempAdultos: Canal[] = [];
    let arrayTempAplicaciones: Canal[] = [];
    let arrayTempNombreProdSEL: Canal[] = [];

    // Solo Adultos
    arrayTempAdultos = canales.filter((canal) => canal.tipo === "ADULTOS");
    // Remueve duplicados
    arrayTempAdultos = removeDuplicates(arrayTempAdultos);

    // Solo Aplicaciones que no son NombreProdSEL
    arrayTempAplicaciones = canales.filter(
      (canal) =>
        canal.tipo !== "ADULTOS" &&
        !canal.nombre.toLowerCase().includes("nombreprodsel")
    );
    // Remueve duplicados
    arrayTempAplicaciones = removeDuplicates(arrayTempAplicaciones);

    // Solo NombreProdSEL
    arrayTempNombreProdSEL = canales.filter((canal) =>
      canal.nombre.toLowerCase().includes("nombreprodsel")
    );
    // Remueve duplicados NombreProdSEL
    arrayTempNombreProdSEL = removeDuplicatesNombreProdSEL(
      arrayTempNombreProdSEL
    );

    /* Aplica las reglas del negocio */

    // // Permite el upgrade de Disney+ Estándar a Disney+ Premium,
    // // pero no el downgrade

    // Si tiene Disney+ Premium remueve Disney+ Estándar
    arrayTempAplicaciones = ifHasProductRemoveChannel(
      "Disney+ Premium", // Busca Disney+ Premium en los productos de la cuenta
      "Disney+ Estándar", // Elimina el canal que contenga la subcadena Disney+ Estándar en el campo nombreProductoCRM
      ConsultaCuentaRestRet!, // Respuesta de la consulta de cuenta (para determinar los productos de la cuenta)
      arrayTempAplicaciones // Arreglo de canales de aplicaciones
    )!;

    // // Temporalmente remueve Disney+ Estándar y Disney+ Premium,
    // // para los que tienen Disney+, Star+ o Combo+

    // Si tiene Disney+, remueve Disney+ Estándar y Disney+ Premium
    arrayTempAplicaciones = ifHasProductRemoveChannelList(
      "Servicio Disney+", // Busca Disney+ de oferta anterior en los productos de la cuenta
      ["Disney+ Estándar", "Disney+ Premium"], // Elimina el canal que contenga la subcadena Disney+ Estándar en el campo nombreProductoCRM
      ConsultaCuentaRestRet!, // Respuesta de la consulta de cuenta (para determinar los productos de la cuenta)
      arrayTempAplicaciones // Arreglo de canales de aplicaciones
    )!;

    // Si tiene Star+, remueve Disney+ Estándar y Disney+ Premium
    arrayTempAplicaciones = ifHasProductRemoveChannelList(
      "Servicio OTT Star+", // Busca Star+ oferta anterior en los productos de la cuenta
      ["Disney+ Estándar", "Disney+ Premium"], // Elimina el canal que contenga la subcadena Disney+ Estándar en el campo nombreProductoCRM
      ConsultaCuentaRestRet!, // Respuesta de la consulta de cuenta (para determinar los productos de la cuenta)
      arrayTempAplicaciones // Arreglo de canales de aplicaciones
    )!;

    // Si tiene Combo+, remueve Disney+ Estándar y Disney+ Premium
    arrayTempAplicaciones = ifHasProductRemoveChannelList(
      "Servicio OTT Combo+", // Busca Disney Combo+ oferta anterior en los productos de la cuenta
      ["Disney+ Estándar", "Disney+ Premium"], // Elimina el canal que contenga la subcadena Disney+ Estándar en el campo nombreProductoCRM
      ConsultaCuentaRestRet!, // Respuesta de la consulta de cuenta (para determinar los productos de la cuenta)
      arrayTempAplicaciones // Arreglo de canales de aplicaciones
    )!;

    /* Termina las reglas del negocio */

    /* Combina los arreglos */
    arrayTempAplicaciones = arrayTempAplicaciones.concat(
      arrayTempNombreProdSEL
    );

    /* Asigna los arreglos a los estados */
    setArrayAdultos(arrayTempAdultos);
    setArrayAplicaciones(arrayTempAplicaciones);

    ordenaArreglo(arrayTempAplicaciones);
    isLoading(false);
    //----------------------------------------------------------------------------------------------------------------------------
  };

  const getServiceFamilyFlag = (
    p_ConsultaCuentaRespuesta: ConsultaCuenta_Respuesta,
    p_nombreservicio: string
  ) => {
    let retorno = false;

    let InstanceComponentArray: InstanceComponent[] =
      p_ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0].ListOfServiceInstance?.ServiceInstance.find(
        (x: ServiceInstance) =>
          x.ServiceProductType === "VIDEO" &&
          x.SlaveHierarchy === "Master" &&
          x.StatusCode === "Activo"
      )?.ListOfInstanceComponent?.InstanceComponent!;

    if (
      InstanceComponentArray === undefined ||
      InstanceComponentArray === null
    ) {
      InstanceComponentArray = [];
    }

    InstanceComponentArray.map(
      (instanceComponent: InstanceComponent, index: number) => {
        let nombreProducto = instanceComponent.Product;

        if (
          nombreProducto.toLowerCase().includes(p_nombreservicio.toLowerCase())
        ) {
          retorno = true;
        }
      }
    );

    return retorno;
  };

  const doConsultaCuentaRest = async () => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      const ConsultaCuentaRestEntrada: ConsultaCuentaRest_Entrada =
        builtConsultaCuentaRestInput(`${sessionStorage.getItem("cuenta")}`);
      let ConsultaCuentaRestParametros = ConsultaCuentaRest_Parametros(
        ConsultaCuentaRestEntrada
      );

      let ConsultaCuentaRespuesta: ConsultaCuenta_Respuesta = await ConsultaWS(
        ConsultaCuentaRestParametros
      );

      if (
        ConsultaCuentaRespuesta.EBMHeaderResponse &&
        ConsultaCuentaRespuesta.EBMHeaderResponse.ErrorNegocio.Estado ===
          "ok" &&
        ConsultaCuentaRespuesta.EBMHeaderResponse.ErrorTecnico.code === "ok"
      ) {
        setConsultaCuentaRespuesta(ConsultaCuentaRespuesta);
        return ConsultaCuentaRespuesta;
      } else {
        console.error("Error al ejecutar el servicio");
        console.error(ConsultaCuentaRespuesta);
        return null;
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error("Error al ejecutar el servicio");
      console.error(error);
      return null;
      // Expected output: ReferenceError: nonExistentFunction is not defined
      // (Note: the exact output may be browser-dependent)
    }
  };

  const validateDUplicades = (p_completearray: Canal[], p_newvalue: string) => {
    var retorno = false;
    for (let u = 0; u < p_completearray.length; u++) {
      if (
        p_newvalue === p_completearray[u].nombre ||
        p_newvalue === p_completearray[u].nombreProductoCRM
      ) {
        retorno = true;
        break;
      }
    }
    return retorno;
  };

  const removeDuplicates = (input_array: Canal[]) => {
    var array = input_array.filter(function (elem, index, self) {
      return index === self.findIndex((t) => t.nombre === elem.nombre);
    });

    return array;
  };

  const removeDuplicatesNombreProdSEL = (input_array: Canal[]) => {
    var array = input_array.filter(function (elem, index, self) {
      return (
        index ===
        self.findIndex((t) => t.nombreProductoCRM === elem.nombreProductoCRM)
      );
    });

    return array;
  };

  const ifHasProductRemoveChannel = (
    product_to_lookup: string,
    remove_channel: string,
    ConsultaCuentaRestRet: ConsultaCuenta_Respuesta,
    array: Canal[]
  ) => {
    if (getServiceFamilyFlag(ConsultaCuentaRestRet!, product_to_lookup)) {
      return (array = array.filter((canal: Canal) => {
        return !canal.nombre
          .toLowerCase()
          .includes(remove_channel.toLowerCase());
      }));
    } else {
      return array;
    }
  };

  const ifHasProductRemoveChannelList = (
    products_to_lookup: string,
    to_remove_channels: string[],
    ConsultaCuentaRestRet: ConsultaCuenta_Respuesta,
    array: Canal[]
  ) => {
    let retorno = array;

    to_remove_channels.forEach((remove_channel: string) => {
      if (getServiceFamilyFlag(ConsultaCuentaRestRet!, products_to_lookup)) {
        retorno = retorno.filter((canal: Canal) => {
          return !canal.nombre
            .toLowerCase()
            .includes(remove_channel.toLowerCase());
        });
      }
    });

    return retorno;
  };

  const ifHasProductRemoveChannelNombreProdSEL = (
    product_to_lookup: string,
    remove_channel: string,
    ConsultaCuentaRestRet: ConsultaCuenta_Respuesta,
    array: Canal[]
  ) => {
    if (getServiceFamilyFlag(ConsultaCuentaRestRet!, product_to_lookup)) {
      return (array = array.filter((canal: Canal) => {
        return !canal.nombreProductoCRM
          .toLowerCase()
          .includes(remove_channel.toLowerCase());
      }));
    } else {
      return array;
    }
  };

  const ifHasProductRemoveChannelNombreProdSELList = (
    products_to_lookup: string,
    to_remove_channels: string[],
    ConsultaCuentaRestRet: ConsultaCuenta_Respuesta,
    array: Canal[]
  ) => {
    let retorno = array;

    to_remove_channels.forEach((remove_channel: string) => {
      if (getServiceFamilyFlag(ConsultaCuentaRestRet!, products_to_lookup)) {
        retorno = retorno.filter((canal: Canal) => {
          return !canal.nombreProductoCRM
            .toLowerCase()
            .includes(remove_channel.toLowerCase());
        });
      }
    });

    return retorno;
  };

  const ordenaArreglo = (ar: any) => {
    let arregloTemp: any = [];

    ordenParaArreglo.forEach((item) => {
      ar.forEach((obj: any) => {
        if (
          ((obj.nombre as string).toLowerCase() !== "nombreprodsel" &&
            obj.nombre === item.original) ||
          ((obj.nombre as string).toLowerCase() === "nombreprodsel" &&
            obj.nombreProductoCRM === item.original)
        ) {
          obj.nombre = item.nuevo;
          // if (item.descripcion !== undefined && item.descripcion !== null) {
          //     obj.descripcion = item.descripcion;
          // }

          arregloTemp.push(obj);
        }
      });
    });

    setArregloOrdenado(arregloTemp);
  };

  return (
    <>
      <Loading isLoading={loading} />

      {muestraTabsAdultosCarta ? (
        <TabsAdultosCarta
          muestra1={setMuestraTabsAdultosCarta}
          indice1={setIndice}
          arrayAdultos1={arrayAdultos}
          arrayAplicaciones1={arregloOrdenado}
          origen1={setOrigen}
        />
      ) : origen === "aplicaciones" ? (
        <CanalCmpnt
          titulo1={arregloOrdenado[indice].nombre}
          imagen1={arregloOrdenado[indice].imagen}
          imagenSmall1={arregloOrdenado[indice].imagen}
          precio1={arregloOrdenado[indice].precio}
          descripcion1={arregloOrdenado[indice].descripcion}
          canal1={arregloOrdenado[indice].canal}
          categoria1={arregloOrdenado[indice].categoria}
          nombrecrm1={arregloOrdenado[indice].nombreProductoCRM}
          muestra1={setMuestraTabsAdultosCarta}
          consultaCuentaRespuesta1={consultaCuentaRespuesta}
        />
      ) : origen === "adultos" ? (
        <CanalCmpnt
          titulo1={arrayAdultos[indice].nombre}
          imagen1={arrayAdultos[indice].imagen}
          imagenSmall1={arrayAdultos[indice].imagen}
          precio1={arrayAdultos[indice].precio}
          descripcion1={arrayAdultos[indice].descripcion}
          canal1={arrayAdultos[indice].canal}
          categoria1={arrayAdultos[indice].categoria}
          nombrecrm1={arrayAdultos[indice].nombreProductoCRM}
          muestra1={setMuestraTabsAdultosCarta}
          consultaCuentaRespuesta1={consultaCuentaRespuesta}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default Cartelera;
